export default "__VITE_ASSET__b92d0f97__"